import React from 'react';

import { Column, Row } from 'app/shopify/components/layout';

import { Signals, type SignalsValidation } from './Signals';

const VALIDATIONS: SignalsValidation[] = ['none', 'error', 'success', 'warning', 'info'];

export function SignalsShowcase() {
  return (
    <Column gap="spacing.general.x3" padding="spacing.general.x4">
      <Row gap="spacing.general.x2">
        {VALIDATIONS.map((validation) => (
          <Signals
            key={`filled-default-${validation}`}
            label="Signal label"
            type="primary"
            size="default"
            validation={validation}
          />
        ))}
      </Row>

      <Row gap="spacing.general.x2">
        {VALIDATIONS.map((validation) => (
          <Signals
            key={`filled-small-${validation}`}
            label="Signal label"
            type="primary"
            size="small"
            validation={validation}
          />
        ))}
      </Row>

      <Row gap="spacing.general.x2">
        {VALIDATIONS.map((validation) => (
          <Signals
            key={`inverted-default-${validation}`}
            label="Signal label"
            type="primary"
            size="default"
            validation={validation}
            inverted
          />
        ))}
      </Row>

      <Row gap="spacing.general.x2">
        {VALIDATIONS.map((validation) => (
          <Signals
            key={`inverted-small-${validation}`}
            label="Signal label"
            type="primary"
            size="small"
            validation={validation}
            inverted
          />
        ))}
      </Row>

      <Row gap="spacing.general.x2">
        {VALIDATIONS.map((validation) => (
          <Signals
            key={`outlined-default-${validation}`}
            label="Signal label"
            type="secondary"
            size="default"
            validation={validation}
          />
        ))}
      </Row>

      <Row gap="spacing.general.x2">
        {VALIDATIONS.map((validation) => (
          <Signals
            key={`outlined-small-${validation}`}
            label="Signal label"
            type="secondary"
            size="small"
            validation={validation}
          />
        ))}
      </Row>
    </Column>
  );
}
